import React, { useState } from "react";
import styles from "../../styles/PokemonItem.module.css";

// import stylesTypes from '../../styles/Types.modules.css'

// import getTypeColor from '../../utils/TypeColor';
import getTypeAura from "../../utils/TypeAura";
import getTypeBall from "../../utils/TypeBall";
import Classnames from "../../utils/Classnames";
import typeChart from "../../utils/data/typeChart.json"; // Import du typeChart
import levelData from "../../utils/data/levelMilestones.json"; // Ajoutez cet import

const PokemonDetails = ({ pokemon }) => {
  if (!pokemon) return null;

  const { detailsClassName, checkedClassName } = Classnames({ pokemon }); // On passe les props récupérées depuis Dashboard directement à travers ce fichier de cette manière

  // Fonction pour obtenir les icônes des types
  const getTypeIcons = (typeJson) => {
    try {
      const types = JSON.parse(typeJson);
      const icons = types.map((type) => {
        // Garder la casse d'origine car les clés dans typeChart sont en majuscules
        const iconPath = typeChart[type];
        console.log(`Type: ${type}, Icon path: ${iconPath}`);
        // Utiliser directement le chemin du typeChart
        return iconPath || "";
      });
      return icons;
    } catch (error) {
      console.error("Erreur lors du parsing du type:", error);
      return [];
    }
  };

  // Calculer le pourcentage d'expérience (à adapter selon votre logique de niveau)
  const calculateExpPercentage = () => {
    const currentXP = pokemon.experience;
    const currentLevel = pokemon.lvl;

    // Trouver les seuils d'XP du niveau actuel et du niveau suivant
    const currentLevelData = levelData.find(
      (data) => data.level === currentLevel
    );
    const nextLevelData = levelData.find(
      (data) => data.level === currentLevel + 1
    );

    // Si c'est le niveau maximum (100)
    if (!nextLevelData) {
      return 100;
    }

    // XP nécessaire pour le niveau actuel
    const baseXP = currentLevelData ? currentLevelData.exp : 0;
    // XP nécessaire pour le niveau suivant
    const nextLevelXP = nextLevelData.exp;

    // Calculer la progression entre le niveau actuel et le suivant
    const xpForNextLevel = nextLevelXP - baseXP;
    const currentProgress = currentXP - baseXP;

    // Calculer le pourcentage
    return (currentProgress / xpForNextLevel) * 100;
  };

  return (
    <div className={`${detailsClassName} ${checkedClassName}`}>
      <div className={styles.detailsContent}>
        {/* <div className={`${styles.videoContainer}`}>
                    <video className={sizeClassName} src={pokemon.video} autoPlay loop muted></video>
                </div> */}

        <div className={`${styles.stats_container}`}>
          <div className={styles.stats}>
            <div className={styles.stats_body}>
              <div className={styles.history_container}>
                <div className={styles.pokeball_container}>
                  <svg
                    width="70"
                    height="70"
                    viewBox="0 0 245 245"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M244.879 128H167.725C165.238 150.5 146.163 168 123 168C99.8372 168 80.7617 150.5 78.2747 128H0.121338C2.9978 193.102 56.6882 245 122.5 245C188.312 245 242.002 193.102 244.879 128ZM244.919 118H167.725C165.238 95.5 146.163 78 123 78C99.8372 78 80.7617 95.5 78.2747 118H0.0810547C2.44873 52.4297 56.3518 0 122.5 0C188.648 0 242.551 52.4297 244.919 118ZM97.9646 99.2441C104.381 92.7539 113.108 89.0703 122.235 89H122.765C131.892 89.0703 140.619 92.7539 147.035 99.2441C153.452 105.736 157.035 114.506 157 123.633C156.965 132.76 153.314 141.5 146.848 147.941C140.382 154.383 131.627 158 122.5 158C113.373 158 104.618 154.383 98.1519 147.941C91.6855 141.5 88.0354 132.76 88.0002 123.633C87.9651 114.506 91.5481 105.736 97.9646 99.2441Z"
                      fill={`${getTypeBall(pokemon.type)}`}
                    />
                  </svg>
                </div>
                <div className={`${styles.name}`}>
                  {/* <p>{pokemon.number}</p> */}
                  <div className={styles.infos}>
                    <p>{pokemon.nom}</p>
                    <p>{pokemon.behavior}</p>
                  </div>
                  <div className={styles.typeIcons}>
                    {getTypeIcons(pokemon.type).map((iconPath, index) => {
                      console.log(
                        `Rendering icon ${index} with path:`,
                        iconPath
                      ); // Pour déboguer
                      return (
                        <img
                          key={index}
                          src={iconPath}
                          alt={`Type ${index + 1}`}
                          className={styles.typeIcon}
                        />
                      );
                    })}
                  </div>
                </div>

                <div className={styles.separator}></div>

                <p>{pokemon.description}</p>

                <div className={styles.separator}></div>

                <p>
                  {pokemon.gender === "Female"
                    ? "Adoptée"
                    : pokemon.gender === "Genderless"
                    ? "Adopté.e"
                    : "Adopté"}{" "}
                  le {pokemon.encounterDay}, à {pokemon.encounterHour}
                </p>
              </div>

              <div className={styles.exp_container}>
                <div className={styles.lvl}>
                  <p>Nv. {pokemon.lvl}</p>
                </div>

                <div className={styles.exp_bar}>
                  <div
                    className={styles.exp_progress}
                    style={{ width: `${calculateExpPercentage()}%` }}
                  ></div>
                </div>
                {/* <p>{pokemon.experience}</p> */}
              </div>
            </div>
          </div>
          {/* <div className={`${styles.topPokeball} pokeball`}>
                        <img src="assets/icons/UI/top_pokeball.png" alt="" />
                    </div> */}
        </div>
      </div>
    </div>
  );
};

export default PokemonDetails;
